// extracted by mini-css-extract-plugin
module.exports = {"buttonsGroup":"SwitchButton_buttonsGroup__2feuE","buttonActive":"SwitchButton_buttonActive__dZclN"};